<script type="text/javascript">
    import {post,get} from './request';
    import { Message, Loading } from 'element-ui';
    // const CommImgHttp = "https://xxjy.camh.org.cn/";
    const CommImgHttp = "https://rps.camh.org.cn/";
    // const CommImgHttp = "http://192.168.249.176/";
    const CommEditor = {
            placeholder: "请在这里输入",
            modules:{
                toolbar:[
                      ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
                      ['blockquote', 'code-block'],     //引用，代码块
                      [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
                      [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
                      [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
                      [{ 'direction': 'rtl' }],             // 文本方向
                      [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
                      [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
                      [{ 'font': [] }],     //字体
                      [{ 'align': [] }],    //对齐方式
                      ['clean'],    //清除字体样式
                      ['image','video']    //上传图片、上传视频
                      ]
            }
    }
    function isPhone(val) {
        var myreg=/^[1][3-9][0-9]{9}$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    function isEmail(val) {
        // 改进的邮箱正则表达式：更严格的验证规则
        // 用户名部分：必须以字母或数字开头和结尾，中间可以包含点、下划线、连字符，但不能连续出现点
        // 域名部分：必须以字母或数字开头和结尾，至少包含一个点分隔的域名部分
        if (!val || typeof val !== 'string') {return false;}
        // 基本格式检查：必须包含@符号
        if (val.indexOf('@') === -1 || val.indexOf('@') !== val.lastIndexOf('@')) {return false;}
        // 检查不能以点、下划线、连字符开头或结尾
        if (/^[._-]|[._-]$/.test(val.split('@')[0])) {return false;}
        // 检查不能有连续的点
        if (/\.\./.test(val.split('@')[0])) {return false;}
        // 标准邮箱格式验证
        var myreg=/^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    function isCard(val) {
        var myreg=/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    var FileUpData = (flie,suc)=>{
        post("api/common/upload",flie)
        .then((res) => {
            if(res.data.code == 1) {
                suc(res.data)
            }else{
                Message({ message: res.data.msg, type: 'error' });
            }
        })
    };
    function _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    }
    function _isFileName(name) {
        let url = name.url?String(name.url):String(name);
    	const fileExtension = url.split('.').pop().toLowerCase();
        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
              return CommImgHttp+url;
              break;
            case 'pdf':
              return CommImgHttp+'/img/pdf.png';
              break;
            case 'doc':
            case 'docx':
              return CommImgHttp+'/img/word.png';;
              break;
            case 'xls':
            case 'xlsx':
                return CommImgHttp+'/img/exel.png';;
                break;
            case 'zip':
            case 'rar':
                return CommImgHttp+'/img/ysb.png';
                break;
        }
    }
    function goTime(val) {
        var timestamp4 = new Date(val*1000);
        //利用拼接正则等手段转化为yyyy-MM-dd hh:mm:ss 格式
        return timestamp4.toLocaleDateString().replace(/\//g, "-") + " " + timestamp4.toTimeString().substr(0,8);
    }
    // 预览文件 - 支持在线预览 PDF 和 Word 文档
    function previewFile(fileUrl) {
        if (!fileUrl) {
            Message({ message: '文件地址不能为空', type: 'error' });
            return;
        }
        
        // 处理文件URL，支持对象形式 {url: 'xxx'} 或字符串形式
        let url = typeof fileUrl === 'object' && fileUrl.url ? fileUrl.url : fileUrl;
        
        // 如果不是完整URL，拼接基础URL
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = CommImgHttp + url;
        }
        
        // 获取文件扩展名
        const fileExtension = url.split('.').pop().toLowerCase().split('?')[0]; // 移除可能的查询参数
        
        // 根据文件类型选择预览方式
        switch (fileExtension) {
            case 'pdf':
                // PDF 文件直接在浏览器中预览
                window.open(url, '_blank');
                break;
            case 'doc':
            case 'docx':
                // Word 文档使用 Microsoft Office Online Viewer 在线预览
                // 注意：此服务要求文件必须可以通过公网 HTTPS 访问
                const officeViewerUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url);
                window.open(officeViewerUrl, '_blank');
                break;
            case 'xls':
            case 'xlsx':
                // Excel 文件使用 Microsoft Office Online Viewer 在线预览
                const excelViewerUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url);
                window.open(excelViewerUrl, '_blank');
                break;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'bmp':
            case 'webp':
                // 图片直接在新窗口打开
                window.open(url, '_blank');
                break;
            default:
                // 其他文件类型直接打开（浏览器会尝试预览或下载）
                window.open(url, '_blank');
                break;
        }
    }
    export default{
        CommImgHttp,
        CommEditor,
        isPhone,
        isEmail,
        isCard,
        FileUpData,
        _isMobile,
        _isFileName,
        goTime,
        previewFile,
    }
</script>
